<template lang="pug">
.article-card
  .cover
    a(:href="localePath('/article/' + info.websiteParam)" target="_blank") {{info.title}}
    img(v-lazy="info.coverImg" :alt="'loklok article cover ' + info.title")
  .right
    h2.right-top
      a.title(:href="localePath('/article/' + info.websiteParam)" target="_blank") {{info.title}}
      .tips
        .time {{info.createTime | formatDate}}
        .tip(v-for='(tag, index) in info.keyword')
          span.dot(v-if="index > 0 && index < info.keyword.length") ·
          span {{tag}}
        .score {{info.doubanScore}}
    .desc {{info.introduction}}
</template>
<script>
import { formatDate } from '@/util'
export default {
  name: 'article-card',
  props: {
    info: {
      type: Object,
      default: () => {}
    }
  },

  filters: {
    formatDate(timestamp) {
      const date = new Date(timestamp)
      return formatDate(date, 'yyyy-MM-dd')
    },
    tags(info) {
      return info?.keyword?.join(' · ')
    }
  }
}
</script>

<style lang="sass" scoped>

.article-card
  @include flex-between
  align-items: flex-start
  .cover
    width: 300px
    height: auto
    margin-right: 18px
    flex-shrink: 0
    height: 168px
    position: relative
    img
      width: 100%
      height: 100%
      border-radius: 8px
      object-fit: cover
    >a
      display: block
      width: 100%
      height: 100%
      z-index: 1
      position: absolute
      opacity: 0
  .right
    flex: 1
    display: flex
    flex-direction: column
    //justify-content: space-between
    .right-top
      .title
        font-size: 24px
        font-weight: bold
        line-height: 150%
        color: $mainTextColor
        letter-spacing: 0
        margin-bottom: 10px
        &:hover
          color: $mainColor
      .tips
        display: flex
        margin-bottom: 10px
        font-weight: bold
        font-size: 14px
        line-height: 120%
        color: $mainDescTextColor
        flex-wrap: wrap
        .time
          margin-right: 20px
        .tip
          .dot
            margin: 0 10px
    .desc
      font-size: 12px
      line-height: 150%
      text-align: justify
      color: $mainDescTextColor
      @include ellipsis-multi(3)
@media screen and (max-width: 750px)
  .article-card
    // height: 112px
    flex-direction: column
    .cover
      width: 100%
      margin-right: 0
      margin-bottom: 12px
      img
        width: 100%
        height: 100%
        border-radius: 8px
        object-fit: cover
    .right
      .right-top
        h2.title
          font-size: 18px
          font-weight: bold
          line-height: 150%
          color: $mainTextColor
          letter-spacing: 0
          margin-bottom: 10px
          &:hover
            color: $mainColor
</style>
